import {
  FETCH_OTP_AUTH_REQUESTS,
  FETCH_OTP_AUTH_REQUESTS_SUCCESS,
  FETCH_OTP_AUTH_REQUESTS_FAILED
} from "../store/types";

const INITIAL_STATE = {
  otpAuthRequest: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const otpauthreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_OTP_AUTH_REQUESTS:
      return {
        ...state,
        loading: true,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_OTP_AUTH_REQUESTS_SUCCESS:
      return {
        ...state,
        otpAuthRequest: action.payload,
        loading: false,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_OTP_AUTH_REQUESTS_FAILED:
      return {
        ...state,
        otpAuthRequest: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    default:
      return state;
  }
}
